import NewsInsightsSearchCombobox from './NewsInsightsSearchCombobox';

export { type NewsInsightsSearchComboboxProps } from './NewsInsightsSearchCombobox';
export default NewsInsightsSearchCombobox;
